import React, { useState } from 'react';
import './topbar.css';

const Topbar = () => {
  const [query, setQuery] = useState('');

  return (
    <div className='topbar'>
      <div className='topbar-search-wrap'>
        <svg className='topbar-search-icon' viewBox='0 0 20 20' fill='none'>
          <circle cx='9' cy='9' r='6' stroke='currentColor' strokeWidth='1.6'/>
          <path d='M14 14l3 3' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round'/>
        </svg>
        <input
          className='topbar-search'
          type='text'
          placeholder='Search…'
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
      </div>
    </div>
  );
};

export default Topbar;